import { cancelRecruitmentApplication } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { CancelRecruitmentCampaignServiceRequest } from './cancel-recruitment-campaign.dto';
import {
  CancelRecruitmentCampaignServiceRequestSchema,
  CancelRecruitmentCampaignServiceResponseSchema,
} from './cancel-recruitment-campaign.dto';

export const cancelRecruitmentCampaignService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(CancelRecruitmentCampaignServiceRequestSchema),
    // NOTE: 204 No Content — 응답 본문 없이 await 만. BE 가 에러면 withApiErrorCapture 가 throw.
    async (request: CancelRecruitmentCampaignServiceRequest): Promise<void> => {
      await cancelRecruitmentApplication(request);
    },
    validateServiceResponse(CancelRecruitmentCampaignServiceResponseSchema),
  ),
);
